import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { useLocation, Link } from "react-router-dom";

const links = [
  { section: "show", label: "О событии" },
  { section: "pianista", label: "Исполнитель" },
  { section: "galeria", label: "Галерея" },
  { section: "venue", label: "Место проведения" },
  { section: "entradas", label: "Получить скидку 20%" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  const handleBrandClick = (e) => {
    if (isHome) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <motion.nav
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500"
      style={{
        background: scrolled ? "rgba(8,6,5,0.75)" : "transparent",
        backdropFilter: scrolled ? "blur(18px)" : "none",
        borderBottom: scrolled ? "1px solid rgba(242,233,222,0.06)" : "none",
      }}
    >
      <div className="container-custom flex items-center justify-between py-5">
        <Link
          to="/"
          data-testid="navbar-brand"
          className="font-serif text-2xl tracking-tight flicker"
          style={{ color: "#F2E9DE" }}
          onClick={handleBrandClick}
        >
          Вечные <span style={{ color: "#E57324", fontStyle: "italic" }}>Шопен</span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {links.map((l) =>
            isHome ? (
              <a
                key={l.section}
                href={`#${l.section}`}
                data-testid={`nav-link-${l.section}`}
                className="text-xs tracking-[0.22em] uppercase text-[#A99F96] hover:text-[#F2E9DE] transition-colors"
              >
                {l.label}
              </a>
            ) : (
              <Link
                key={l.section}
                to={`/#${l.section}`}
                data-testid={`nav-link-${l.section}`}
                className="text-xs tracking-[0.22em] uppercase text-[#A99F96] hover:text-[#F2E9DE] transition-colors"
              >
                {l.label}
              </Link>
            )
          )}
          {isHome ? (
            <a
              href="#fechas"
              data-testid="nav-cta-tickets"
              className="btn-primary !py-2 !px-5 !text-[0.7rem]"
            >
              Билеты
            </a>
          ) : (
            <Link
              to="/#fechas"
              data-testid="nav-cta-tickets"
              className="btn-primary !py-2 !px-5 !text-[0.7rem]"
            >
              Билеты
            </Link>
          )}
        </div>

        <button
          className="md:hidden text-[#F2E9DE]"
          data-testid="navbar-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden"
            style={{ background: "rgba(8,6,5,0.95)" }}
          >
            <div className="container-custom py-6 flex flex-col gap-5">
              {links.map((l) =>
                isHome ? (
                  <a
                    key={l.section}
                    href={`#${l.section}`}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-mobile-link-${l.section}`}
                    className="text-sm tracking-[0.2em] uppercase text-[#A99F96]"
                  >
                    {l.label}
                  </a>
                ) : (
                  <Link
                    key={l.section}
                    to={`/#${l.section}`}
                    onClick={() => setOpen(false)}
                    data-testid={`nav-mobile-link-${l.section}`}
                    className="text-sm tracking-[0.2em] uppercase text-[#A99F96]"
                  >
                    {l.label}
                  </Link>
                )
              )}
              {isHome ? (
                <a
                  href="#fechas"
                  onClick={() => setOpen(false)}
                  className="btn-primary self-start"
                  data-testid="nav-mobile-cta-tickets"
                >
                  Билеты
                </a>
              ) : (
                <Link
                  to="/#fechas"
                  onClick={() => setOpen(false)}
                  className="btn-primary self-start"
                  data-testid="nav-mobile-cta-tickets"
                >
                  Билеты
                </Link>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
}
